import React, { useContext, useEffect, useState } from "react";
import { useParams } from "react-router";
import { CompletionsContext } from "../../../App"
import { CheckCircleIcon, ExclamationCircleIcon, MinusCircleIcon } from "@heroicons/react/24/solid";
import { withTranslation } from "react-i18next";
import handleCondition from "../../../utils/forms/generateForm/handleConditionOnQuestion";


function Recap({ currentStep, setStep, t, readOnly = false, completionToUse = null}) {
  const [completion, setCompletion] = useState({});
  const [completions] = useContext(CompletionsContext);
  let { id } = useParams();

  useEffect(() => {
    setCompletion(completionToUse ? {...completionToUse, steps: completionToUse.stepsCandidature} : completions && completions.find(c => c.id === id));
  }, [completions, id, completionToUse])

  function canEditStep(index) {
    if (readOnly) return false;
    if (!completion?.steps) return false;
    for (let i = index + 1; i <= currentStep; i++) {
      if (!completion.steps[i]?.canGoBack) return false;
    }
    return true;
  }

  return completion && <div className="space-y-6">
    {completion.steps && completion.steps.length > 0 ? completion.steps.filter((s, index) => index < currentStep ? true : false).map((s, index) => {
      var canEdit = !readOnly && canEditStep(index);
      var formData = {};
      s.questions?.forEach(q => { if (q.name) formData[q.name] = q.value ?? ""; });
      const visibleQuestions = s.questions?.filter(q => {
        if (q.hidden || q.subfieldType === "url") return false;
        if ((q.fieldType === "custom input" || q.fieldType === "custom variable")
          && q.object !== "Address" && q.object !== "Stripe" && q.object !== "Paybox") return false;
        if (!q.required && !q.value) return false;
        if (!handleCondition(formData, q, s.questions)) return false;
        return true;
      }) ?? [];
      if (!visibleQuestions.length) return null;

      return <div key={s.id}>
        <div className="flex items-center justify-between mb-3">
          <h2 className="text-base font-bold text-gray-900" lang="fr" translate="yes">{s.name}</h2>
          {canEdit && (
            <button
              onClick={() => setStep(index)}
              className="text-sm font-semibold hover:opacity-75 transition-opacity"
              style={{ color: "var(--primary-color)" }}
            >
              {t("Modifier")}
            </button>
          )}
        </div>
        <div className="bg-gray-50 px-5 py-4" style={{ borderRadius: '12px' }}>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-x-6 gap-y-4">
            {visibleQuestions.map(q => {
              var value = "—";
              if (q.value) {
                if (q.fieldType === "file") {
                  value = <span className="text-gray-500 text-xs">{t("File uploaded")}</span>;
                } else if (q.fieldType === "custom input" && q.object === "Stripe") {
                  value = q.stripe.status === "paid" ? <CheckCircleIcon className="h-5 text-green-500" /> : (q.stripe.status === "waiting" ? <ExclamationCircleIcon className="h-5 text-yellow-500" /> : <MinusCircleIcon className="h-5 text-red-500" />);
                } else if (q.fieldType === "custom input" && q.object === "Paybox") {
                  value = q.value === "paid" ? <CheckCircleIcon className="h-5 text-green-500" /> : (q.paybox.status === "waiting" ? <ExclamationCircleIcon className="h-5 text-yellow-500" /> : <MinusCircleIcon className="h-5 text-red-500" />);
                } else if (q.fieldType === "select" || q.fieldType === "booleancheckbox" || q.fieldType === "radio") {
                  value = q?.options?.find(opt => opt.value === q.value)?.label ?? q.value;
                } else if (q.fieldType === "date") {
                  var d = new Date(q.value);
                  value = (d.getDate() < 10 ? "0" + d.getDate() : d.getDate()) + "/" + (d.getMonth() < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1) + "/" + d.getFullYear();
                } else if (q.fieldType === "checkbox" || q.fieldType === "selectmultiple") {
                  var listValues = q.value.split(";");
                  value = q.options.filter(opt => listValues.includes(opt.value)).map(opt => opt.label).join(", ");
                } else {
                  value = q.value;
                }
              } else if (q.fieldType === "custom input" && q.object === "Address") {
                var parts = [];
                q.options.forEach(opt => {
                  if (!opt.hidden && s.questions.find(sq => sq.id === opt.value)) {
                    var locq = s.questions.find(sq => sq.id === opt.value);
                    if (locq.value) parts.push(locq.value);
                  }
                });
                value = parts.join(", ") || "—";
              }
              return (
                <div key={q.id} className="min-w-0">
                  <p className="text-xs text-gray-400 mb-0.5">{q.label}</p>
                  <p className="text-sm text-gray-800 font-medium break-words">{value}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>;
    }) : null}
  </div>
}

export default withTranslation()(Recap);